export default __webpack_public_path__ + "static/media/empty-reservation.58920d78.png";